<template>
    <div>
        <!-- Modal nouveaux créneaux (ChantierInit) -->
        <modal name="modal-new-creneaux" height="auto" :scrollable="true" :adaptive="true" width="90%">
            <div class="p-8 overflow-y-auto max-h-[100vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b">
                    <h2 class="text-xl font-bold flex items-center gap-2">
                        <i class="fas fa-folder-open text-red-600"></i>
                        Nouveau créneau d'intervention
                    </h2>
                    <button @click="$modal.hide('modal-new-creneaux')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="chantier">
                    <chantier-init :chantier-id="chantier.id" @slots-created="onSlotsCreated" />
                </div>
            </div>
        </modal>

        <!-- Modal nouvelle intervention -->
        <modal name="modal-nouvelle-intervention" height="auto" :scrollable="true" :adaptive="true" width="70%">
            <div class="overflow-y-auto max-h-[100vh]">
                <div class="flex items-center justify-between px-8 pt-8 pb-4 border-b">
                    <h2 class="text-xl font-bold flex items-center gap-2">
                        <i class="fas fa-plus text-red-600"></i>
                        Nouvelle intervention
                    </h2>
                    <button @click="$modal.hide('modal-nouvelle-intervention')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <div v-if="chantier" class="bg-white">
                    <!-- En-tête avec bouton Planifier -->
                    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
                        <p class="text-xs text-gray-400">Sélectionnez un ou plusieurs appareils et configurez le type d'intervention</p>
                        <button
                            :disabled="parcAppareils.length === 0 || loadingPlanifierParc"
                            @click="planifierParc"
                            class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold transition-all"
                            :class="parcAppareils.length > 0 && !loadingPlanifierParc
                                ? 'bg-red-600 hover:bg-red-700 text-white shadow-sm'
                                : 'bg-gray-100 text-gray-400 cursor-not-allowed'"
                        >
                            <i v-if="loadingPlanifierParc" class="fas fa-spinner fa-spin"></i>
                            <i v-else class="fas fa-check"></i>
                            Créer l'intervention
                            <span v-if="parcAppareils.length > 0"
                                class="bg-white text-red-600 text-xs font-black px-1.5 py-0.5 rounded-md leading-none">
                                {{ parcAppareils.length }}
                            </span>
                        </button>
                    </div>

                    <appareils-parc
                        :client-id="chantier.client_id"
                        :chantier-id="chantier.id"
                        :coordonnees="chantierCoordonnees"
                        @change="onParcChange"
                        ref="appareilsParc"
                    />
                </div>
            </div>
        </modal>

        <!-- Modal view intervention -->
        <modal name="modal-view-intervention" height="auto" :scrollable="true" :adaptive="true" width="850px">
            <div class="p-8 overflow-y-auto max-h-[100vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b">
                    <h2 class="text-xl font-bold flex items-center gap-2">
                        <i class="fas fa-folder-open text-red-600"></i>
                        Intervention
                    </h2>
                    <button @click="$modal.hide('modal-view-intervention')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="selectedIntervention">
                    <intervention-view :intervention-id="selectedIntervention.id" />
                </div>
            </div>
        </modal>

        <div class="space-y-6">
            <!-- Skeleton chargement -->
            <div v-if="loadingGetChantier" class="space-y-6">
                <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <div class="flex-1">
                            <div class="h-8 bg-gray-200 rounded w-64 mb-2"></div>
                            <div class="h-4 bg-gray-200 rounded w-32"></div>
                        </div>
                        <div class="flex items-center gap-4">
                            <div class="h-6 bg-gray-200 rounded-full w-24"></div>
                            <div class="h-8 w-8 bg-gray-200 rounded-full"></div>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-100 p-1.5 rounded-xl inline-flex gap-1">
                    <div v-for="i in 5" :key="i" class="h-10 bg-gray-200 rounded-lg w-32"></div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                        <div class="h-6 bg-gray-200 rounded w-48 mb-4"></div>
                        <div class="space-y-4">
                            <div v-for="i in 4" :key="i" class="flex justify-between items-center pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-16"></div>
                                <div class="h-4 bg-gray-200 rounded w-32"></div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                        <div class="h-6 bg-gray-200 rounded w-48 mb-4"></div>
                        <div class="space-y-4">
                            <div class="pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                                <div class="h-4 bg-gray-200 rounded w-full mb-1"></div>
                            </div>
                            <div class="h-20 bg-gray-200 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!loadingGetChantier && chantier" class="space-y-6">
                <!-- Tabs -->
                <div class="bg-gray-100 p-1.5 rounded-xl inline-flex flex-wrap gap-1">
                    <button
                        v-for="tab in tabs" :key="tab.id"
                        @click="selectedTab = tab.id"
                        :class="[
                            selectedTab === tab.id
                                ? 'bg-white text-red-600 shadow-sm font-semibold'
                                : 'text-gray-500 hover:text-gray-800 hover:bg-gray-200 font-medium',
                            'px-5 py-2 rounded-lg text-sm transition-all duration-200 flex items-center cursor-pointer'
                        ]"
                    >
                        <i :class="[tab.icon, 'mr-2', selectedTab === tab.id ? 'text-red-500' : 'text-gray-400']"></i>
                        {{ tab.label }}
                    </button>
                </div>

                <div class="mt-4">

                    <!-- ── Onglet Info ── -->
                    <div v-show="selectedTab === 'info'" class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <div id="intervention-map-chantier" class="w-full h-[452px] md:h-[452px] rounded-lg shadow"></div>
                        </div>
                        <div class="space-y-6">
                            <div v-if="!chantier.terminer">
                                <button :disabled="loadingTerminer" @click="terminer" class="bg-yellow-500 hover:bg-yellow-600 duration-200 text-white px-4 py-2 rounded-lg">
                                    <i v-if="loadingTerminer" class="fas fa-spinner fa-spin"></i>
                                    <template v-else><i class="fas fa-ban mr-1"></i> Terminer le chantier</template>
                                </button>
                            </div>
                            <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                                <h2 class="text-lg font-semibold mb-4 text-gray-800">Lieu d'intervention</h2>
                                <div class="space-y-4">
                                    <div class="pb-3 border-b border-gray-50">
                                        <span class="block text-sm text-gray-500 mb-1">Adresse complète</span>
                                        <div class="font-medium text-gray-800">{{ chantier.adresse.adresse1 }}</div>
                                        <div v-if="chantier.adresse.adresse2" class="text-sm text-gray-600">{{ chantier.adresse.adresse2 }}</div>
                                        <div class="text-sm text-gray-600">{{ chantier.adresse.code_postal }} {{ chantier.adresse.ville }}</div>
                                    </div>
                                    <div v-if="chantier.adresse.nom_contact" class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Contact sur place</span>
                                        <span class="font-medium text-gray-800">{{ chantier.adresse.nom_contact }}</span>
                                    </div>
                                    <div v-if="chantier.adresse.acces" class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Code d'accès</span>
                                        <span class="font-mono bg-gray-100 px-2 py-1 rounded text-gray-800 text-sm">{{ chantier.adresse.acces }}</span>
                                    </div>
                                    <div v-if="chantier.adresse.notes">
                                        <span class="block text-sm text-gray-500 mb-1">Notes importantes</span>
                                        <p class="text-sm text-gray-700 bg-gray-50 p-3 rounded-lg border border-gray-100">{{ chantier.adresse.notes }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                                <h2 class="text-lg font-semibold mb-4 text-gray-800">Détails du Client</h2>
                                <div class="space-y-4">
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Nom</span>
                                        <span class="font-medium text-gray-800 capitalize">{{ chantier.client.nom }} {{ chantier.client.prenom }}</span>
                                    </div>
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Type</span>
                                        <span class="font-medium text-gray-800 capitalize">{{ chantier.client.type_client }}</span>
                                    </div>
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Email</span>
                                        <a :href="'mailto:' + chantier.client.email" class="text-sm font-medium text-red-600 hover:underline">{{ chantier.client.email }}</a>
                                    </div>
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Téléphone</span>
                                        <a :href="'tel:' + chantier.client.telephone" class="text-sm font-medium text-red-600 hover:underline">{{ chantier.client.telephone }}</a>
                                    </div>
                                    <div v-if="chantier.client.siret" class="flex justify-between items-center">
                                        <span class="text-sm text-gray-500">SIRET</span>
                                        <span class="text-sm font-medium text-gray-800">{{ chantier.client.siret }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ── Onglet Interventions ── -->
                    <div v-if="selectedTab === 'interventions'" class="space-y-6">
                        <template v-if="loadingReloadIntervention">
                            <div class="flex flex-col items-center justify-center py-16 bg-white rounded-2xl border border-gray-100 shadow-sm">
                                <div class="relative w-16 h-16 mb-4">
                                    <div class="absolute inset-0 rounded-full border-4 border-gray-100"></div>
                                    <div class="absolute inset-0 rounded-full border-4 border-red-500 border-t-transparent animate-spin"></div>
                                </div>
                                <p class="text-sm font-semibold text-gray-700">Chargement des interventions</p>
                                <p class="text-xs text-gray-400 mt-1">Veuillez patienter...</p>
                            </div>
                        </template>

                        <template v-if="!loadingReloadIntervention">
                            <!-- Barre de temps -->
                            <div class="p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div class="flex justify-between items-end mb-4">
                                    <div>
                                        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider">Planification du temps</h3>
                                        <p class="text-2xl font-bold" :class="chantierTemps.isOverflow ? 'text-red-600' : 'text-slate-800'">
                                            {{ chantierTemps.reste.toFixed(1) }} <span class="text-lg font-medium text-gray-400">heures restantes</span>
                                        </p>
                                    </div>
                                    <div class="text-right">
                                        <span class="text-sm font-medium text-gray-600">
                                            {{ chantierTemps.totalPlanifie.toFixed(1) }}h / {{ chantierTemps.totalDispo.toFixed(1) }}h
                                        </span>
                                    </div>
                                </div>
                                <div class="relative w-full h-4 bg-gray-100 rounded-full overflow-hidden">
                                    <div
                                        class="h-full transition-all duration-500 ease-out"
                                        :class="[
                                            chantierTemps.isOverflow ? 'bg-red-500' : 'bg-emerald-500',
                                            chantierTemps.pourcentage > 90 && !chantierTemps.isOverflow ? 'bg-orange-400' : ''
                                        ]"
                                        :style="{ width: (chantierTemps.pourcentage > 100 ? 100 : chantierTemps.pourcentage) + '%' }"
                                    ></div>
                                </div>
                                <div class="flex mt-3 items-center justify-between">
                                    <div class="flex gap-4">
                                        <div class="flex items-center text-xs text-gray-500">
                                            <span class="w-2 h-2 rounded-full bg-emerald-500 mr-2"></span> Planifié
                                        </div>
                                        <div class="flex items-center text-xs text-gray-500">
                                            <span class="w-2 h-2 rounded-full bg-gray-200 mr-2"></span> Disponible
                                        </div>
                                    </div>
                                    <div v-if="chantierTemps.isOverflow" class="flex items-center text-xs font-bold text-red-600 bg-red-50 px-2 py-1 rounded">
                                        <i class="fas fa-exclamation-triangle mr-1"></i> Dépassement de {{ Math.abs(chantierTemps.reste).toFixed(1) }}h
                                    </div>
                                </div>
                                <div v-if="chantierTemps.isOverflow" class="bg-red-100 text-red-600 text-sm font-medium mt-4 px-3 py-2 rounded">
                                    <i class="fas fa-exclamation-circle mr-1"></i>
                                    Le temps total planifié dépasse le temps disponible pour ce chantier.<br />
                                    Veuillez planifier de nouveaux créneaux.<br />
                                    <button @click="$modal.show('modal-new-creneaux')" class="mt-2 bg-red-600 hover:bg-red-700 duration-200 text-white px-4 py-2 rounded-lg">
                                        <i class="fas fa-calendar-alt mr-1"></i> Planifier de nouveaux créneaux
                                    </button>
                                </div>
                            </div>

                            <!-- Bouton + Table interventions -->
                            <div class="overflow-hidden bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
                                    <h3 class="text-sm font-semibold text-gray-800">Interventions planifiées</h3>
                                    <button
                                        @click="$modal.show('modal-nouvelle-intervention')"
                                        class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold bg-red-600 hover:bg-red-700 text-white shadow-sm transition-all"
                                    >
                                        <i class="fas fa-plus"></i>
                                        Nouvelle intervention
                                    </button>
                                </div>
                                <table class="w-full text-sm text-left">
                                    <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                                        <tr>
                                            <th class="px-6 py-3">Référence</th>
                                            <th class="px-6 py-3">Type</th>
                                            <th class="px-6 py-3">Statut</th>
                                            <th class="px-6 py-3">Technicien</th>
                                            <th class="px-6 py-3">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-100">
                                        <tr
                                            class="hover:bg-red-50 duration-200 cursor-pointer"
                                            v-for="intervention in chantier.interventions"
                                            :key="intervention.id"
                                            @click.stop="selectedIntervention = intervention; $modal.show('modal-view-intervention')"
                                        >
                                            <td class="px-6 py-4 font-medium text-gray-800">{{ intervention.reference }}</td>
                                            <td class="px-6 py-4 text-xs text-gray-800">{{ intervention.intervention_type?.nom || '-' }}</td>
                                            <td class="px-6 py-4 text-xs font-light">{{ intervention.statut.libelle }}</td>
                                            <td class="px-6 py-4 text-gray-600">
                                                <span v-if="intervention.technicien">{{ intervention.technicien.prenom }} {{ intervention.technicien.nom }}</span>
                                                <span v-else class="text-gray-400 italic">Non assigné</span>
                                            </td>
                                            <td class="px-6 py-4 text-gray-600">
                                                <div class="flex items-center justify-between gap-2">
                                                    {{ intervention.date_intervention ? new Date(intervention.date_intervention).toLocaleDateString('fr-FR') : '-' }}
                                                    <button
                                                        v-if="intervention.statut.code === 'a_planifier'"
                                                        @click.stop="supprimerIntervention(intervention.id)"
                                                        class="px-2 py-1 text-red-500 rounded"
                                                    >
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="chantier.interventions.length === 0">
                                            <td colspan="5" class="px-6 py-6 text-center text-gray-400">Aucune intervention</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </div>

                    <!-- ── Onglet Planning ── -->
                    <div v-if="selectedTab === 'planning'" class="space-y-6">
                        <button @click="$modal.show('modal-new-creneaux')" class="mb-4 bg-red-600 hover:bg-red-700 duration-200 text-white px-4 py-2 rounded-lg">
                            <i class="fas fa-plus mr-1"></i> Planifier de nouveaux créneaux
                        </button>
                        <div v-if="chantier" class="border rounded-lg shadow-sm border-gray-100 p-2">
                            <planning-half-day
                                :heure-debut-matin="$account.account.societe.heure_ouverture ? $account.account.societe.heure_ouverture.slice(0, 5) : '08:00'"
                                heurefin-matin="12:00"
                                heure-debut-apres-midi="12:01"
                                :heure-fin-apres-midi="$account.account.societe.heure_fermeture ? $account.account.societe.heure_fermeture.slice(0, 5) : '17:00'"
                                :readonly="true"
                                :chantier-id="chantier.id"
                                :days="$account.account.societe.open_days"
                                :can-open-chantier="false"
                            />
                        </div>
                    </div>

                    <!-- ── Onglet Documents ── -->
                    <div v-if="selectedTab === 'documents'" class="grid grid-cols-2 md:grid-cols-6 gap-6">
                        <div class="col-span-2">
                            <div class="bg-gradient-to-br from-gray-50 to-white rounded-2xl border-2 border-dashed border-gray-200 p-6 mb-6 hover:border-red-300 transition-all">
                                <div class="flex items-center gap-3 mb-4">
                                    <div class="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
                                        <i class="fas fa-plus text-red-600"></i>
                                    </div>
                                    <h3 class="text-lg font-semibold text-gray-800">Ajouter un document</h3>
                                </div>
                                <div class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            <i class="fas fa-paperclip text-red-500 mr-1"></i> Fichier
                                        </label>
                                        <input-file key-name="doc-intervention" v-model="newDoc.url" :preview="false" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            <i class="fas fa-tag text-red-500 mr-1"></i> Type de document
                                        </label>
                                        <div class="relative">
                                            <select v-model="newDoc.type" class="w-full border border-gray-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-red-500 focus:border-red-500 transition appearance-none bg-white pr-10 text-gray-800">
                                                <option value="" disabled selected>Sélectionner un type</option>
                                                <option v-for="(label, type) in docTypeLabel" :key="type" :value="type">{{ label }}</option>
                                            </select>
                                            <i class="fas fa-chevron-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                                        </div>
                                    </div>
                                    <button :disabled="loadingAddDoc" @click="addDocument"
                                        class="w-full px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-xl font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none">
                                        <template v-if="loadingAddDoc"><i class="fas fa-spinner fa-spin"></i><span>Ajout en cours...</span></template>
                                        <template v-else><i class="fas fa-upload"></i><span>Ajouter le document</span></template>
                                    </button>
                                </div>
                            </div>
                            <div v-if="chantier.client.email" class="bg-gradient-to-br from-gray-50 to-white rounded-2xl border-2 border-dashed border-gray-200 p-6 mb-6 hover:border-red-300 transition-all">
                                <div class="flex items-center gap-3 mb-4">
                                    <div class="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
                                        <i class="fas fa-paper-plane text-red-600"></i>
                                    </div>
                                    <h3 class="text-lg font-semibold text-gray-800">Envoyer les documents</h3>
                                </div>
                                <p class="text-sm text-gray-600 mb-4">Renvoyer les documents du chantier au client par email.</p>
                                <button :disabled="loadingResendDocuments" @click="resendDocuments"
                                    class="px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-xl font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2">
                                    <template v-if="loadingResendDocuments"><i class="fas fa-spinner fa-spin"></i><span>Envoi en cours...</span></template>
                                    <template v-else><i class="fas fa-paper-plane"></i><span>Renvoyer les documents</span></template>
                                </button>
                            </div>
                        </div>
                        <div v-if="!chantier.documents || chantier.documents.filter(d => d.type !== 'facture' && d.type !== 'devis').length === 0" class="col-span-2 md:col-span-4">
                            <div class="bg-white p-6 rounded-2xl border border-gray-100 text-center text-gray-400">
                                <i class="fas fa-folder-open text-4xl mb-3"></i>
                                Aucun document trouvé.
                            </div>
                        </div>
                        <div class="col-span-2 md:col-span-4">
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                <div
                                    v-for="doc in chantier.documents.filter(d => d.type !== 'facture' && d.type !== 'devis')"
                                    :key="'doc-' + doc.id"
                                    class="bg-white rounded-2xl border border-gray-100 p-5 hover:border-red-300 hover:shadow-sm transition-all cursor-pointer text-center group"
                                >
                                    <a :href="doc.url" target="_blank" class="block w-full">
                                        <i :class="[
                                            'text-4xl mb-3 group-hover:scale-110 transition-transform inline-block',
                                            doc.type === 'pdf' ? 'fas fa-file-pdf text-red-500' :
                                            doc.type === 'image' ? 'fas fa-file-image text-gray-600' :
                                            doc.type === 'word' ? 'fas fa-file-word text-blue-600' :
                                            doc.type === 'excel' ? 'fas fa-file-excel text-green-600' :
                                            'fas fa-file text-gray-400'
                                        ]"></i>
                                        <h4 class="text-sm font-semibold text-gray-800 truncate">{{ docTypeLabel[doc.type] }}</h4>
                                        <p v-if="doc.appareil" class="text-xs text-gray-500 mt-1 truncate">{{ doc.appareil.marque }} {{ doc.appareil.model }}</p>
                                        <p v-if="doc.manually" class="text-xs text-gray-500 mt-1 truncate">Ajouté manuellement</p>
                                        <p v-if="doc.type == 'bon_intervention' && !doc.intervention_id" class="text-xs text-gray-500 mt-1 truncate">Lié au chantier</p>
                                        <button @click.prevent="removeDoc(doc.id)" v-if="doc.manually" class="text-xs text-gray-500 hover:text-red-500 duration-200 mt-1 truncate">Supprimer</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ── Onglet Facturation ── -->
                    <div v-if="selectedTab === 'facturation'">
                        <facturation-list-table
                            v-if="chantier"
                            :chantier-id="chantier.id"
                            :client-id="chantier.client_id"
                            :adresse-id="chantier.adresse_id"
                            @invoice-created="getChantier(false)"
                        />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FacturationListTable from './../../Facturation/FacturationListTable.vue'
import ChantierInit         from './ChantierInit.vue'
import AppareilsParc        from './../../Client/Components/AppareilsParc.vue'
import DocType              from './../../../config/docType.js'
import InterventionView     from '../../Intervention/Components/InterventionView.vue'
import PlanningHalfDay      from './../../Planning/Components/PlanningHalfDay.vue'

export default {
    components: {
        InterventionView,
        PlanningHalfDay,
        FacturationListTable,
        ChantierInit,
        AppareilsParc,
    },

    props: {
        chantierId: { type: Number, required: true },
        defaultTab: { type: String, default: 'info' },
    },

    watch: {
        chantierId: { immediate: true, handler() { this.getChantier() } },
        defaultTab: { immediate: true, handler(val) { this.selectedTab = val } },
    },

    data() {
        return {
            selectedTab: 'info',
            tabs: [
                { id: 'info',          label: 'Informations', icon: 'fas fa-info-circle' },
                { id: 'interventions', label: 'Interventions', icon: 'fas fa-clipboard-check' },
                { id: 'planning',      label: 'Planning',      icon: 'fas fa-calendar-alt' },
                { id: 'documents',     label: 'Documents',     icon: 'fas fa-box-archive' },
            ],

            chantier: null,
            docTypeLabel: DocType,
            loadingGetChantier: true,
            loadingReloadIntervention: false,

            newDoc: { url: '', type: '' },
            loadingAddDoc: false,

            selectedIntervention: null,
            _interventionMap: null,
            loadingTerminer: false,
            loadingResendDocuments: false,

            /**
             * Snapshot des appareils configurés dans AppareilsParc.
             * Mis à jour via @change. Transmis à ChantierInit pour pré-remplir
             * la sélection d'appareils lors de la planification.
             */
            parcAppareils: [],
            loadingPlanifierParc: false,
        }
    },

    computed: {
        /**
         * Coordonnées stables (computed) pour éviter de recréer l'objet
         * à chaque render et déclencher une boucle dans AppareilsParc.
         */
        chantierCoordonnees() {
            const adr = this.chantier?.adresse
            if (!adr?.latitude) return null
            return { latitude: adr.latitude, longitude: adr.longitude }
        },

        chantierTemps() {
            const events        = this.chantier?.planning_events || []
            const interventions = this.chantier?.interventions   || []
            const totalDispoMinutes    = events.reduce((a, e) => a + (e.estimation || 0), 0)
            const totalPlanifieMinutes = interventions.reduce((a, i) => a + (parseFloat(i.duree_estimee) || 0), 0)
            const resteMinutes  = totalDispoMinutes - totalPlanifieMinutes
            const pourcentage   = totalDispoMinutes > 0 ? Math.round((totalPlanifieMinutes / totalDispoMinutes) * 100) : 0
            return {
                totalDispo:    totalDispoMinutes / 60,
                totalPlanifie: totalPlanifieMinutes / 60,
                reste:         resteMinutes / 60,
                pourcentage,
                isOverflow:    totalPlanifieMinutes > totalDispoMinutes,
            }
        },
    },

    methods: {
        /* ── Chantier ── */
        async getChantier(loading = true) {
            if (loading) this.loadingGetChantier = true
            try {
                this.chantier = await this.$request.post(`/chantiers/${this.chantierId}/view`)
            } catch (e) {
                console.error(e)
            } finally {
                this.loadingGetChantier = false
                this.showInterventionMap()
                this.$forceUpdate()
            }
        },

        showInterventionMap() {
            const adr = this.chantier?.adresse
            if (!adr?.latitude || !adr?.longitude) return
            mapboxgl.accessToken = 'pk.eyJ1IjoidmljdG9yYW53IiwiYSI6ImNrajhuam1iOTZ1dnQydnFqbzRldDJrdW8ifQ.VkIKVhh5_Pcp7PxqQ-GCCg'
            window.setTimeout(() => {
                if (this._interventionMap) this._interventionMap.remove()
                this._interventionMap = new mapboxgl.Map({
                    container: 'intervention-map-chantier',
                    style: 'mapbox://styles/mapbox/streets-v12',
                    center: [parseFloat(adr.longitude), parseFloat(adr.latitude)],
                    zoom: 14,
                })
                new mapboxgl.Marker({ color: '#e11d48' })
                    .setLngLat([parseFloat(adr.longitude), parseFloat(adr.latitude)])
                    .addTo(this._interventionMap)
            }, 400)
        },

        async terminer() {
            if (!confirm('Êtes-vous sûr de vouloir terminer ce chantier ? Cette action est irréversible.')) return
            this.loadingTerminer = true
            await this.$request.post('/chantiers/cloturer', { chantier_id: this.chantier.id })
            this.$toast.success('Chantier clôturé')
            this.$emit('chantier-ended')
            this.loadingTerminer = false
        },

        async supprimerIntervention(id) {
            if (!confirm('Supprimer cette intervention ?')) return
            await this.$request.post(`/interventions/${id}/delete`)
            this.$toast.success('Intervention supprimée')
            this.getChantier(false)
        },

        /* ── Documents ── */
        async addDocument() {
            if (!this.newDoc.url)  { this.$toast.error('Veuillez sélectionner un fichier.'); return }
            if (!this.newDoc.type) { this.$toast.error('Veuillez sélectionner un type.'); return }
            this.loadingAddDoc = true
            await this.$request.post('/interventions/add-doc', { url: this.newDoc.url, type: this.newDoc.type, chantier_id: this.chantier.id })
            this.loadingAddDoc = false
            this.newDoc = {}
            this.$toast.success('Document ajouté avec succès.')
            this.getChantier(false)
        },

        async removeDoc(docId) {
            if (!confirm('Êtes-vous sûr de vouloir supprimer ce document ?')) return
            await this.$request.post('/interventions/remove-doc', { id: docId })
            this.getChantier(false)
        },

        async resendDocuments() {
            this.loadingResendDocuments = true
            try {
                await this.$request.post('chantier/send-documents', { chantier_id: this.chantier.id })
                this.$toast.success('Documents renvoyés au client avec succès.')
            } catch { this.$toast.error("Une erreur est survenue lors de l'envoi.") }
            finally { this.loadingResendDocuments = false }
        },

        /* ── Parc appareils ── */

        onParcChange(appareils) {
            this.parcAppareils = appareils
        },

        async planifierParc() {
            if (this.parcAppareils.length === 0) return
            this.loadingPlanifierParc = true
            try {
                await this.$request.post('/interventions/planifier-json', {
                    chantier_id: this.chantier.id,
                    client_id:   this.chantier.client_id,
                    adresse_id:  this.chantier.adresse_id,
                    appareils:   this.parcAppareils,
                })
                this.$toast.success('Intervention(s) créée(s) avec succès')
                this.$modal.hide('modal-nouvelle-intervention')
                this.parcAppareils = []
                if (this.$refs.appareilsParc) {
                    this.$refs.appareilsParc.addedDevices = []
                    this.$refs.appareilsParc.closeDevicePanel()
                }
                this.loadingReloadIntervention = true
                await this.getChantier(false)
                this.loadingReloadIntervention = false
            } catch (e) {
                console.error(e)
                this.$toast.error('Une erreur est survenue.')
            } finally {
                this.loadingPlanifierParc = false
            }
        },

        /* ── Créneaux (modal-new-creneaux existant) ── */
        onSlotsCreated() {
            this.$modal.hide('modal-new-creneaux')
            if (this.selectedTab === 'planning') {
                this.selectedTab = null
                this.$nextTick(() => { this.selectedTab = 'planning' })
            }
        },
    },

    mounted() {
        this.getChantier()
        this.selectedTab = this.defaultTab
        if (this.$account.account.societe.manage_facturation) {
            this.tabs.push({ id: 'facturation', label: 'Facturation', icon: 'fas fa-file-invoice-dollar' })
        }
    },
}
</script>